<script>
export default {
  created() {
    this.collapsible = true;
  },
  data() {
    return {
      collapsed: true,
    };
  },
  methods: {
    collapse(force) {
      if (typeof force === 'boolean') {
        this.collapsed = force;
      } else {
        this.collapsed = !this.collapsed;
      }
    },
    collapseChildren(force) {
      this.$children.forEach((child) => {
        if (child.collapsible) {
          child.collapse(force);
          child.collapseChildren(force);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/form_builder/CollapsibleMixin.vue